/**
 * Custom Cricket Bat Builder
 * Handles selection state, price calculation, preview updates, and Add to Cart.
 */
(function () {
  const form = document.getElementById('bat-builder-form');
  if (!form) return;

  const variantIdInput = form.querySelector('[name="id"]');
  const variantId = form.dataset.productId;
  const totalEl = document.getElementById('bat-total-price');
  const addBtn = document.getElementById('bat-add-to-cart');
  const addError = document.getElementById('bat-add-error');
  const previewSelections = document.getElementById('preview-selections');

  const radios = form.querySelectorAll('.custom-bat-builder__input');
  let basePrice = parseInt(form.dataset.basePrice || '0', 10);

  function getSelectedOptions() {
    const opts = {};
    form.querySelectorAll('.custom-bat-builder__fieldset').forEach(function (fieldset) {
      const key = fieldset.dataset.optionGroup;
      const radio = fieldset.querySelector('.custom-bat-builder__input:checked');
      if (radio) {
        opts[key] = {
          label: radio.dataset.choiceLabel || radio.value,
          priceModifier: parseInt(radio.dataset.priceModifier || '0', 10),
          previewImage: radio.dataset.previewImage || ''
        };
      }
    });
    return opts;
  }

  function updateSelectionState() {
    form.querySelectorAll('.custom-bat-builder__choice').forEach(function (label) {
      const radio = label.querySelector('.custom-bat-builder__input');
      label.classList.toggle('is-selected', radio && radio.checked);
    });
  }

  function updateTotal() {
    const options = getSelectedOptions();
    let total = basePrice;
    Object.keys(options).forEach(function (key) {
      total += options[key].priceModifier;
    });
    if (totalEl) {
      totalEl.textContent = formatMoney(total);
    }
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function updatePreview() {
    const options = getSelectedOptions();
    if (!previewSelections) return;

    const parts = [];
    Object.keys(options).forEach(function (key) {
      const o = options[key];
      const label = key.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      if (o.previewImage) {
        parts.push('<img src="' + escapeHtml(o.previewImage) + '" alt=""> ' + escapeHtml(o.label));
      } else {
        parts.push('<strong>' + escapeHtml(label) + ':</strong> ' + escapeHtml(o.label));
      }
    });

    previewSelections.innerHTML = parts.length
      ? parts.join('<br>')
      : '';
  }

  function escapeHtml(s) {
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function initBasePrice() {
    if (basePrice > 0) return;
    fetch('/products/' + form.dataset.productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        const v = product.variants && product.variants[0];
        if (v && typeof v.price === 'number') {
          basePrice = v.price;
          updateTotal();
        }
      })
      .catch(function () {});
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      updateSelectionState();
      updateTotal();
      updatePreview();
    });
  });

  updateSelectionState();
  updateTotal();
  updatePreview();
  initBasePrice();

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!addBtn) return;

    addError.hidden = true;
    addError.textContent = '';
    addBtn.disabled = true;

    const options = getSelectedOptions();
    const properties = {};
    Object.keys(options).forEach(function (key) {
      properties[key] = options[key].label;
    });

    const body = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: properties
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (result.ok) {
          if (typeof window.theme !== 'undefined' && window.theme.openCart) {
            window.theme.openCart();
          } else if (typeof Shopify !== 'undefined' && Shopify.onCartUpdate) {
            Shopify.onCartUpdate(result.data);
          }
          addBtn.disabled = false;
        } else {
          addError.textContent = result.data.description || result.data.message || 'Could not add to cart.';
          addError.hidden = false;
          addBtn.disabled = false;
        }
      })
      .catch(function () {
        addError.textContent = 'Network error. Please try again.';
        addError.hidden = false;
        addBtn.disabled = false;
      });
  });
})();
